import { render, staticRenderFns } from "./stockHistory.vue?vue&type=template&id=7960e1b0&scoped=true&"
import script from "./stockHistory.vue?vue&type=script&lang=js&"
export * from "./stockHistory.vue?vue&type=script&lang=js&"
import style0 from "./stockHistory.vue?vue&type=style&index=0&id=7960e1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960e1b0",
  null
  
)

export default component.exports